import { z } from 'zod';
import { TarefaStatus } from './enums.js';
import { BoolQuery, CompetenciaChave, CompetenciaChaveQuery, DataISO, Id } from './comum.js';

/** Fechamento do mês: por cliente, o que falta em cada obrigação da competência. */
export const FechamentoQuery = z.object({
  /** sem ela, o mês anterior (em outubro fecha-se setembro) */
  competenciaChave: CompetenciaChaveQuery.optional(),
  clienteId: Id.optional(),
  departamento: z.string().trim().max(8).optional(),
  responsavelMembroId: Id.optional(),
  busca: z.string().trim().max(120).optional(),
  /** só clientes com algo pendente */
  soPendentes: BoolQuery.optional(),
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(10).max(200).default(50),
});
export type FechamentoQuery = z.infer<typeof FechamentoQuery>;

/**
 * O que falta numa obrigação. ABERTA/ATRASADA, SEM_ENTREGA e NAO_PUBLICADA travam o fechamento;
 * SEM_EMAIL e as de guia são avisos (o escritório já fez a parte dele).
 */
export const PendenciaFechamento = z.enum(['ABERTA', 'ATRASADA', 'SEM_ENTREGA', 'ENTREGAVEL_FALTANDO', 'DOCUMENTO_SEM_DADOS_DE_GUIA', 'NAO_PUBLICADA', 'SEM_EMAIL', 'GUIA_A_PAGAR', 'GUIA_VENCIDA']);
export type PendenciaFechamento = z.infer<typeof PendenciaFechamento>;

export const ItemFechamento = z.object({
  tarefaId: Id, sigla: z.string(), nome: z.string(), departamento: z.string().nullable(), vencimento: DataISO, status: TarefaStatus, responsavel: z.string().nullable(),
  entregas: z.number().int(), guias: z.number().int(), guiasPagas: z.number().int(), publicados: z.number().int(), enviadoEmailEm: z.string().nullable(),
  pendencias: z.array(PendenciaFechamento), fechada: z.boolean(),
});
export type ItemFechamento = z.infer<typeof ItemFechamento>;

export const FechamentoResposta = z.object({
  competenciaChave: CompetenciaChave,
  linhas: z.array(z.object({
    clienteId: Id, nome: z.string(), documento: z.string(), regime: z.string().nullable(), itens: z.array(ItemFechamento), fechado: z.boolean(), pendentes: z.number().int(),
  })),
  resumo: z.object({
    clientes: z.number().int(), clientesFechados: z.number().int(), tarefas: z.number().int(), fechadas: z.number().int(), abertas: z.number().int(), atrasadas: z.number().int(),
    semEntrega: z.number().int(), naoPublicadas: z.number().int(), guiasAPagar: z.number().int(),
    /** concluídas devendo o que geram, e arquivos publicados com nome de guia sem vencimento e valor */
    faltaGera: z.number().int().default(0), semDadosGuia: z.number().int().default(0),
  }),
  paginacao: z.object({ page: z.number().int(), perPage: z.number().int(), total: z.number().int() }),
});
export type FechamentoResposta = z.infer<typeof FechamentoResposta>;
